"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * ResourceTagLoader
 */
var ResourceTagLoader = /*#__PURE__*/function () {
  function ResourceTagLoader() {
    _classCallCheck(this, ResourceTagLoader);
  }

  _createClass(ResourceTagLoader, null, [{
    key: "loadCss",

    /**
     * Load a script by adding a script tag.
     *
     * @param {object} args Args.
     * @param {string} args.url What to load.
     * @param {HTMLElement} args.parent Where to add tag.
     * @returns {Promise<void>} - Resolved when ready.
     */
    value: function loadCss(_ref) {
      var url = _ref.url,
          _ref$parent = _ref.parent,
          parent = _ref$parent === void 0 ? document.head : _ref$parent;
      var element = document.createElement('link');
      var promise = this.waitForTagLoad(element);
      element.href = url;
      element.setAttribute('type', 'text/css');
      element.setAttribute('rel', 'stylesheet');
      parent.appendChild(element);
      return promise;
    }
    /**
     * Load a script by adding a script tag.
     *
     * @param {object} args Args.
     * @param {string} args.url What to load.
     * @param {HTMLElement} args.parent Where to add tag.
     * @returns {Promise<void>} - Resolved when ready.
     */

  }, {
    key: "loadScript",
    value: function loadScript(_ref2) {
      var url = _ref2.url,
          _ref2$parent = _ref2.parent,
          parent = _ref2$parent === void 0 ? document.head : _ref2$parent;
      var element = document.createElement('script');
      var promise = this.waitForTagLoad(element);
      element.src = url;
      element.async = 1;
      parent.appendChild(element);
      return promise;
    }
    /**
     * Promizify tag load.
     *
     * @param {HTMLElement} htmlElement What to load.
     * @returns {Promise<void>} - Resolved when ready.
     */

  }, {
    key: "waitForTagLoad",
    value: function waitForTagLoad(htmlElement) {
      return new Promise(function (resolve, reject) {
        htmlElement.addEventListener('load', resolve);
        htmlElement.addEventListener('error', reject);
      });
    }
  }]);

  return ResourceTagLoader;
}();

exports.default = ResourceTagLoader;